module.exports = __webpack_public_path__ + "media/images/soar/operation_file-66798cf1e7f84a0ff07f6f0b8b6d67a6.png";